import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../../components/table/Table2'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'
import { VariableAccountType } from './VariableAccountType'
import { ColumnAccountType } from '../../../../components/general/general-component/columns-component/ColumnAccountType'
import { deleteAccountType, loadAccountTypes } from '../../../../store/Actions/ActionAccountType'
import AddAccountType from './AddAccountType'
import EditAccountType from './EditAccountType'

const AccountType = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { account_types, loadingAccountTypes } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableAccountType()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [accountTypeArr, setAccountTypeArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...accountTypeArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setAccountTypeArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, accountTypeArr]);
    useEffect(() => {
        if (account_types?.length >= 0) {
            setAccountTypeArr(account_types)
        }
    }, [account_types]);
    useEffect(() => {
        dispatch(loadAccountTypes())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteAccountType(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openAccountType = e => {
        e.preventDefault()
        setOpen(true)
    }
    const { columns } = ColumnAccountType(translate, warning, handleEdit, langLocal)
    return (
        <>
            <>
                {/*<FilterUser translate={translate} />*/}
                <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('account_type')} titleBtn={translate('add_account_type')} FunctionBtn={openAccountType} />
                    {
                        loadingAccountTypes == false ? (
                            <Table2 col={columns} roo={accountTypeArr} />
                        ) : <InnerLoader />
                    }
                </div>
            </>
            {
                state.open && (
                    <AddAccountType open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditAccountType arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </>
    )
}

export default AccountType

